export const ARIA_LABEL = 'dropzone'
export const DATA_TEST_ID_PLACEHOLDER = 'draggable-placeholder'
export const DATA_TEST_ID_DROP_ZONE_PREFIX = 'dropzone-'
export const DATA_TEST_ID_DROP_ZONE_TITLE_SUFFIX = '-title'
export const NO_PLACEHOLDER_HEIGHT = 0
